export default __webpack_public_path__ + "static/media/dkny.8a39a271.pdf";